<template>
  <!-- toast -->
  <AlertMsg :msg="msgObj.msg" :show="msgObj.show" :role="msgObj.role" @closePopup="msgObj.show = false"></AlertMsg>
  <!-- end toast -->
  <div class="row">
    <div class="col-12">
      <div class="d-flex align-items-center mt-2">
        <h5 class="mb-0 text-primary"><i class="fas fa-school text-primary"></i> General Setting</h5>
      </div>
      <hr />
      <div class="row g-3">
        <div class="col-md-3">
          <label class="form-label">Name :</label>
          <input class="form-control form-control-sm" type="text" v-model="Obj.Name" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Mobile No. :</label>
          <input class="form-control form-control-sm" type="number"  @input="limitDigits($event, 10, v => Obj.MobileNo = v)" v-model="Obj.MobileNo" />
        </div>
        <div class="col-md-3">
          <label class="form-label">Email :</label>
          <input class="form-control form-control-sm" type="email" v-model="Obj.Email" />
        </div>
      <div class="col-md-10">
        </div>
        <div class="col-md-3">
          <label class="form-label">Address<sup><span class="text-danger font-12">*</span></sup>
            :</label>
          <textarea class="form-control form-control-sm rounded" aria-label="With textarea" v-model="Obj.Address"></textarea>
        </div>
        <div class="col-md-3">
          <label class="form-label">Logo :</label>
         <label for="fileInput" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
          <input class="form-control" id="fileInput" type="file" multiple accept=".png,.jpg,.jpeg,.webp,.pdf,.docx,.doc,.xls,.txt" @change="UploadImg" />
          <div class="d-flex align-items-start">
          <a :href="getUrl(Obj.Image)" target="_blank"  class="clearfix">{{Obj.Image.substring(Obj.Image.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="Obj.Image !== ''" @click="deleteFile(Obj.Image, 'Image')" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>
        <div class="col-md-3">
          <img :src="`${apiUrl}${Obj.Image}`" width="75px;" alt="logo icon"  role="button"/>
        </div>
      </div>
       <div class="col-md-3">
          <label class="form-label">Login Banner :</label>
         <label for="fileImage" class="attachment-icon" >
              <i class="fa fa-upload"></i>
            </label>
         <input class="form-control form-control-sm" id="fileImage" type="file" multiple @change="FileUploadImg" />
         <div class="d-flex align-items-start"> 
         <a :href="getUrl(Obj.loginBnr)" target="_blank"  class="clearfix">{{Obj.loginBnr.substring(Obj.loginBnr.lastIndexOf('/') + 1)  }} </a>
          <i role="button" v-if="Obj.loginBnr !== ''" @click="deleteFile(Obj.loginBnr, 'Photo')" class="fa-solid fa-x text-danger f-5 mt-2 ms-1"></i>
        </div></div>
      <div class="col-md-9 text-end mt-2">
        <button class="btn btn-sm btn-darknavy " @click="save()">
          <i class="fa fa-save"></i> Save
        </button>
      </div>
    </div>
  </div>
   <ul v-if="errors.length" class="text-danger ps-3">
        <li v-for="(err, index) in errors" :key="index">{{ err }}</li>
      </ul>
  <p v-if="msgObj.show && msgObj.role === 'success'" class="text-danger">
  After Updating Changes Logout & Login to display the Updated Changes
</p>
</template>
<script setup>
import AlertMsg from "@/components/Common/AlertMsg.vue";
import { useFileUpload } from '@/utils/fileUpload';
const { handleFileUploadImg } = useFileUpload()
import { isRequired, validateForm, } from "@/utils/validation.js";
import { curdStatus, api } from '@/utils/helpers.js';
import { ref, onMounted} from 'vue'
 const apiUrl= ref(process.env.VUE_APP_API_URL)
  const  Obj = ref( { Name: "",MobileNo:"", Email: "" ,Address: "", Image: "", loginBnr :"", })
  const List= ref([])
    const   msgObj= ref({ msg: "", role: "", show: false, })
    const   errors= ref({})
const limitDigits = (event, max, assignFn) => {
  let val = event.target.value.toString().slice(0, max);
  assignFn(val.replace(/\D/g, ''));
}
const  save =async() => {
      const fields = {
        Address: { value: Obj.value.Address, validators: [isRequired], },
      };
      errors.value = validateForm(fields);

      if (Object.keys(errors.value).length === 0) {
        const { url, method, msg } = curdStatus(Obj.value);
        await api[method](`/setting${url}`, Obj.value)
          .then((response) => {
            loadData();
            reset();
            msgObj.value = { msg: `GeneralSetting ${msg} Successfuly`, role: "success", show: true, };
            console.log(response);
          })
          .catch((error) => { console.log(error); });
      }
    }
    const FileUploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.loginBnr = uploadedFile; }
  event.target.value = null;
};
   const UploadImg = async (event) => {
  const file = event.target.files[0];
  if (!file) return;
const { file: uploadedFile, message } = await handleFileUploadImg(file);
  if (message) {
    msgObj.value = { msg: message, role: "danger", show: true };
    event.target.value = ""; 
    return;
  }
  if (uploadedFile) { Obj.value.Image = uploadedFile; }
  event.target.value = null;
};
   const reset =async () => {
      Obj.value = { Name: "",MobileNo:"", Email: "", Address: "", Image: "",loginBnr :"", };
      msgObj.value = { msg: "", role: "", show: false, };
      errors.value={};
    }
   const loadData =async () => {
      await api.get('/setting/all')
        .then((response) => {
          List.value = response.data;
          if (response.data.length > 0) {
            Obj.value.Name = response.data[0].Name;
             Obj.value.MobileNo = response.data[0].MobileNo;
            Obj.value.Email = response.data[0].Email;
            Obj.value.Address = response.data[0].Address;
            Obj.value._id = response.data[0]._id;
            Obj.value.Image = response.data[0].Image;
            Obj.value.loginBnr = response.data[0].loginBnr ;
          }
        });
    }
    const deleteFile = async (filePath, field) => {
  if (!filePath) return;
  const fileName = filePath.split('/').pop();
  try {
    await api.delete(`/documents/students?filename=${fileName}`);
    if (field === 'Photo') Obj.value.loginBnr = '';
    if (field === 'Image')  Obj.value.Image = '';
  } catch (err) {
    console.error('Failed to delete file', err);
  }
};
    const getUrl= (img)=> {
      let imgUrl = !img
        ? "/images/Logo.png"
        : img.startsWith("..")
          ? img.substring(2)
          : img;
      
  const base = process.env.VUE_APP_API_URL.replace(/\/+$/, "");
  const path = imgUrl.replace(/^\/+/, "");
  return `${base}/${path}`;
    }
    onMounted(() => { loadData() })
</script>